const Course_content = [
    {
        name: "PROGRAM INTRODUCTION",
        content: <div>
            <div className="summary" id="yui_3_17_2_1_1705400754556_51">
                <div className="no-overflow" id="yui_3_17_2_1_1705400754556_56">
                    <p></p>
                    <p style={{ textAlign: 'center' }}>
                        <span style={{ color: '#000080' }}>
                            __________________________________________________________________________________________________________________________________________
                        </span>
                    </p>
                    <p style={{ textAlign: 'center' }}>
                        <strong>
                            <span style={{ color: '#ff6600' }}>
                                &nbsp;
                                <img
                                    src="https://cdn.eduvahini.com/LOGO/hopelogo.jpeg"
                                    width="125"
                                    height="80"
                                    alt="Hope Logo"
                                />
                                &nbsp; &nbsp; &nbsp;&nbsp;
                            </span>
                            <span style={{ fontSize: 'xx-large', color: '#000080' }}>Welcomes you and wishes you grand </span>
                            <span style={{ fontSize: 'xx-large', color: '#333399' }}>success!!</span>
                        </strong>
                        <span style={{ color: '#333399' }}>&nbsp;</span>
                    </p>
                    <p>
                        __________________________________________________________________________________________________________________________________________
                    </p>
                    <p style={{ textAlign: 'left' }}></p>
                    <p style={{ textAlign: 'left' }}></p>
                    <h3 style={{ textAlign: 'left' }}>
                        <strong>
                            <span style={{ color: '#ff6600' }}>Program Background</span>
                        </strong>
                    </h3>
                    <p style={{ textAlign: 'left' }}>
                        SONY (Donor Partner)&nbsp;in collaboration with Hope Foundation (Implementation Partner) &amp; Experifun (Technology Partner) has brought the AI Python Programming course to students to learn Python and become job ready. The program is a multi-location
                        and multi-lingual program to customize the program for local language to further assist students who may need local language support. The program is designed for a 14-week course.
                    </p>
                    <p style={{ textAlign: 'left' }}></p>
                    <h3 style={{ textAlign: 'left' }} id="yui_3_17_2_1_1705400754556_68">
                        <strong>
                            <span style={{ color: '#ff6600' }}>Program Objective</span>
                        </strong>
                    </h3>
                    <p style={{ textAlign: 'left' }}>
                        Python Programming (Beginner-Advance-Expert) program is a comprehensive program designed to enable students from different parts of the country to learn Python programming to get job ready. The students enrolled in the program would learn the below skills.
                    </p>
                    <ol id="yui_3_17_2_1_1705400754556_55">
                        <li style={{ textAlign: 'left' }} id="yui_3_17_2_1_1705400754556_54">
                            <em>Python Core Programming Skills</em>
                        </li>
                        <li style={{ textAlign: 'left' }}>
                            <em>Interviewing Skills</em>
                        </li>
                        <li style={{ textAlign: 'left' }}>
                            <em>Job Application Skills</em>
                        </li>
                        <li style={{ textAlign: 'left' }}>
                            <em>Understanding of Job portals, Social Media and other avenues for job application&nbsp;&nbsp;</em>
                        </li>
                    </ol>
                    <p style={{ textAlign: 'left' }}>
                        The students will also get to interact with industry experts and experienced professionals for motivational purposes.&nbsp;
                    </p>
                    <p style={{ textAlign: 'left' }}></p>
                    <p style={{ textAlign: 'left' }}></p>
                    <h3 style={{ textAlign: 'left' }}>
                        <strong>
                            <span style={{ color: '#ff6600' }}>How will the program get delivered</span>
                        </strong>
                    </h3>
                    <p style={{ textAlign: 'left' }}>
                        The program has been designed to be delivered online using the EduVahini Online Learning Platform. The platform's approach will enable students to attend not only live classes but also help them get back to those lessons later at their own convenient time.
                    </p>
                    <p style={{ textAlign: 'left' }}></p>
                    <p style={{ textAlign: 'left' }}></p>
                </div>
            </div>


        </div>
    },

    {
        name: "COURSE INTRODUCTION",
        content: <div>
            <div className="content" id="yui_3_17_2_1_1705400754556_58">
                <h3 className="sectionname">
                    <span>
                        <a href="https://hope.eduvahini.com/course/view.php?id=357#section-1">COURSE INTRODUCTION</a>
                    </span>
                </h3>
                <div className="section_availability"></div>
                <div className="summary"></div>
                <ul className="section img-text cs_list mb0" id="yui_3_17_2_1_1705400754556_57">
                    <li className="activity label modtype_label " id="module-66055">
                        <div>
                            <div className="mod-indent-outer">
                                <div className="mod-indent"></div>
                                <div>
                                    <div className="contentwithoutlink">
                                        <div className="no-overflow">
                                            <div className="no-overflow">
                                                <p>
                                                    <span style={{ color: "#ff6600" }}>
                                                        <em>
                                                            <strong>Python Programming - Course & Timeline Structure</strong>
                                                        </em>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="actions">
                                        <span className="autocompletion">
                                            <img
                                                className="icon iconsmall"
                                                title="Students can manually mark this item complete: Python Programming - Course & Timeline Structu..."
                                                alt="Students can manually mark this item complete: Python Programming - Course & Timeline Structu..."
                                                src="https://hope.eduvahini.com/theme/image.php/edumy/core/1687091087/i/completion-manual-enabled"
                                            />
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>
                    {/* ... (similar transformations for other list items) ... */}
                </ul>
            </div>

        </div>
    },

    {
        name: "LIVE CLASSES",
        content: <div>
            <div className="panel-body">
                <span className="hidden sectionname">LIVE CLASSES</span>
                <div className="left side"></div>
                <div className="right side">
                    <img
                        className="icon spacer"
                        width="1"
                        height="1"
                        alt=""
                        aria-hidden="true"
                        src="https://hope.eduvahini.com/theme/image.php/edumy/core/1687091087/spacer"
                    />
                </div>
                <div className="content">
                    <h3 className="sectionname">
                        <span>
                            <a href="https://hope.eduvahini.com/course/view.php?id=357#section-5">LIVE CLASSES</a>
                        </span>
                    </h3>
                    <div className="section_availability"></div>
                    <div className="summary"></div>
                    <ul className="section img-text cs_list mb0">
                        {/* ... Your list items go here ... */}
                    </ul>
                </div>
            </div>
        </div>

    },

    {
        name: "CERTIFICATE",
        content: <div>
            <div className="panel-body">
                <span className="hidden sectionname">CERTIFICATE</span>
                <div className="left side"></div>
                <div className="right side">
                    <img
                        className="icon spacer"
                        width="1"
                        height="1"
                        alt=""
                        aria-hidden="true"
                        src="https://hope.eduvahini.com/theme/image.php/edumy/core/1687091087/spacer"
                    />
                </div>
                <div className="content">
                    <h3 className="sectionname">
                        <span>
                            <a href="https://hope.eduvahini.com/course/view.php?id=357#section-45">CERTIFICATE</a>
                        </span>
                    </h3>
                    <div className="section_availability">
                        <div className="availabilityinfo ishidden">
                            <span className="badge badge-info">Hidden from students</span>
                        </div>
                    </div>
                    <div className="summary"></div>
                    <ul className="section img-text cs_list mb0">
                        <li className="activity certificate modtype_certificate " id="module-66434">
                            <div>
                                <div className="mod-indent-outer">
                                    <div className="mod-indent"></div>
                                    <div>
                                        <div className="activityinstance">
                                            <a className=" dimmed conditionalhidden" onClick="" href="https://hope.eduvahini.com/mod/certificate/view.php?id=66434">
                                                <img
                                                    src="https://hope.eduvahini.com/theme/image.php/edumy/certificate/1687091087/icon"
                                                    className="iconlarge activityicon"
                                                    alt=""
                                                    role="presentation"
                                                    aria-hidden="true"
                                                />
                                                <span className="instancename">PYTHON COURSE COMPLETION CERTIFICATE</span>
                                            </a>
                                        </div>
                                        <span className="actions">
                                            <span className="autocompletion">
                                                <img
                                                    className="icon iconsmall"
                                                    title="Students can manually mark this item complete: PYTHON COURSE COMPLETION CERTIFICATE"
                                                    alt="Students can manually mark this item complete: PYTHON COURSE COMPLETION CERTIFICATE"
                                                    src="https://hope.eduvahini.com/theme/image.php/edumy/core/1687091087/i/completion-manual-enabled"
                                                />
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    }

]

const course_intro = `<h1 class="h1">What is Python?</h1>
 <p>This tutorial is meant for beginners who are just hearing the word Python too often and are wondering what this Python is, mostly high-schoolers who are just starting their BTech. Welcome to the world of programming and technology. This tutorial will be like your introductory brochure into the coding and tech world.</p>
 `

export default Course_content;
export { course_intro };

